import React, { Component } from 'react'
import './stylesCozy.scss'
import { barcodeInfo } from '../../constants/common'
import Modal from 'react-modal'

class BarcodeInfoModal extends Component {
  constructor() {
    super()
    this.state = {
      modal: barcodeInfo
    }
    this.close = this.close.bind(this)
  }

  componentWillReceiveProps(np) {
    if (np.open) {
      this.setState({ modal: barcodeInfo })
    }
  }

  close() {
    this.props.closeModal()
  }

  render() {
    return (
      <div id="registerCozy-page">
        <Modal isOpen={this.props.open} id={this.props.modalType} ariaHideApp={false} overlayClassName="Overlay" className="register-cozy common">
          <div tabIndex="-1" className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <img alt="" className="pop-bg-img" src="/img/scan_bg@3x.svg" />
                <div className="camera-box">
                  <h5 className="modal-title span" id="scan">
                    The label is located on either the left or right side of your Cozy
                  </h5>
                  <img alt="" src="/img/gotit_img.png" />
                  <div className="line_arrow-box">
                    <img className="line_arrow_left" alt="" src="/img/line_arrow_left.svg" />
                    <img className="line_arrow_right" alt="" src="/img/line_arrow_right.svg" />
                  </div>
                </div>
              </div>
              <div className="modal-body">
                <h5 className="modal-title" id="scan-title">
                  This is what the label looks like:
                </h5>
                <div className="camera-box">
                  <img alt="" src="/img/after_scan_img@3x.png" />
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12 text-center">
                  <span className="link" data-dismiss="modal" onClick={this.close}>
                    Got It
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
export default BarcodeInfoModal



// WEBPACK FOOTER //
// ./src/views/Modals/barcodeinfo.js